module.exports = __webpack_public_path__ + "static/glow-effect-1-f4f7a34d0bd4eadac7d5c6078c33e184.png";